import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import greaterThan from "../assets/greaterthan.svg";
import OtpInput from "./otp-login";

interface otpModalDetails {
  otp: string;
  setOtp: (value: string) => void;
  otpSent?: boolean;
  handleOtpValidation: (value: string) => Promise<boolean | void> | void;
  handleSendOtp?: (value: string) => Promise<boolean | void> | void;
  show: boolean;
  setShow: (value: any) => void;
  onHide: () => any;
  email: string;
  verifyError?: string;
}

const EmailOtpModal: React.FC<otpModalDetails> = (props: otpModalDetails) => {
  const [validating, setValidating] = useState(false);
  const [resendStatus, setResendStatus] = useState("");

  const updateOtp = (userOtp: any) => {
    props.setOtp(userOtp);
  };

  const onValidate = async () => {
    setValidating(true);
    const result = await props.handleOtpValidation("email");
    setValidating(false);
    if (result !== false) {
      props.setShow(false);
    }
  };

  const onResend = async () => {
    if (props.handleSendOtp) {
      setResendStatus("Resending...");
      const sent = await props.handleSendOtp("email");
      if (sent) {
        setResendStatus("OTP resent successfully!");
        setTimeout(() => setResendStatus(""), 3000);
      } else {
        setResendStatus("Failed to resend. Please try again.");
      }
    }
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      id="otp-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter" className="modal-title">
          OTP Verification
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body">
        <>
          <p>
            We've sent a 4-digit verification OTP to your email address:{" "}
            <strong>{props.email}</strong>
          </p>

          {props.verifyError && (
            <p className="text-danger text-center mt-2 font-medium" role="alert">
              {props.verifyError}
            </p>
          )}

          {resendStatus && (
            <p className="text-info text-center mt-2 text-sm" role="status">
              {resendStatus}
            </p>
          )}

          <div className="otp-input-container my-3">
            <OtpInput length={4} updateOtp={updateOtp} />
          </div>

          <button
            className="rounded mt-4 button"
            onClick={onValidate}
            disabled={props.otp === "" || validating}
          >
            {validating ? "Validating..." : "Validate OTP"}
            <img src={greaterThan} alt="" aria-hidden="true" />
          </button>

          <div className="text-center mt-3">
            <button
              type="button"
              className="btn btn-link text-decoration-underline p-0"
              style={{ color: "#5030E5", fontSize: "0.9rem" }}
              onClick={onResend}
              disabled={validating}
            >
              Resend OTP
            </button>
          </div>
        </>
      </Modal.Body>
    </Modal>
  );
};

export default EmailOtpModal;
